"use client";
import React, { FC } from "react";
import { useScreen } from "../../context/ScreenContext";
import DesktopLayout from "../DesktopLayout";
import Link from "next/link";
import SupportSidebarMenu from "./SupportSidebarMenu";
import { useTranslations } from "next-intl";
import { I18N_NAMESPACE } from "@/config/i18n";
import SupportSidebarMenuMobile from "./SupportSidebarMenuMobile";

import SVGIcon from "../SVGIcon";

const ProfilePage: FC<{
  children: JSX.Element[] | JSX.Element;
  backButton?: { href: string; text: string };
}> = ({ children, backButton, navigation }) => {
  const { isMobile, isTablet } = useScreen();
  const t = useTranslations(I18N_NAMESPACE.HELP);

  const getContent = () =>
    isMobile || isTablet ? (
      <>
        <SupportSidebarMenuMobile navigation={navigation} />
        {children}
      </>
    ) : (
      <DesktopLayout header={t("help-center")}>
        <div className="flex  p-2 sticky top-10 flex-col w-full h-[calc(100dvh-120px)] overflow-auto text-left transition-all bg-white rounded dark:bg-tertiary-700">
          <SupportSidebarMenu navigation={navigation} />
        </div>
        <>{children}</>
      </DesktopLayout>
    );

  return getContent();
};

export default ProfilePage;
